/* eslint-disable jsx-a11y/alt-text */
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../utils/GlobalContext";
import CalenderImg from "../Assets/Img/calender.svg";
import LocationImg from "../Assets/Img/Location.png";
import DummyImg from "../Assets/Img/Rectangle 21.png";
import NoCamp from "../Assets/Img/amico.svg";
import create from "../Assets/Img/create dashboard.png";
import Search from "../Assets/Img/search.png";
import youtubeDeliverables from "../Assets/Img/youtube deliverables.svg";
import instaDeliverables from "../Assets/Img/insta deliverables.svg";
import "../Brand/Campaign/Campaign.css";
import axiosMain from "../http/axiosMain";
import { SearchBar } from "../Common/Components/SearchBar";

export default function DashboardInfluencer() {
  const { userData } = useContext(GlobalContext);
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [startDate, setStartDate] = useState("");
  const location = useLocation();
  const [statusCounts, setStatusCounts] = useState({});

  const [campaignRequests, setCampaignRequests] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Initialize activeTab:
  const [activeTab, setActiveTab] = useState(() => {
    return (
      localStorage.getItem("activeTab") ||
      location.state?.activeTab ||
      "Received"
    );
  });

  const ViewDetails = (id) => {
    localStorage.setItem("dashboardpath", location.pathname);
    navigate(`/influancer-details/${id}`);
  };

  // useEffect to store the active tab in localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState(data);
  const [endDate, setEndDate] = useState("");
  const [contentTypes, setContentTypes] = useState([
    {
      platform: "Instagram",
      items: [
        { id: "reels", label: "Reels", count: 1, checked: false },
        { id: "posts", label: "Posts", count: 1, checked: false },
        { id: "story", label: "Story", count: 1, checked: false },
      ],
    },
    {
      platform: "YouTube",
      items: [
        { id: "shorts", label: "Shorts", count: 1, checked: false },
        { id: "video", label: "Video", count: 1, checked: false },
        { id: "liveStream", label: "Live Stream", count: 1, checked: false },
      ],
    },
  ]);

  // Filter logic for search (add this to apply search on data load or query change)
  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(data); // No filter if empty
    } else {
      const lowerCaseQuery = searchQuery.toLowerCase();
      const filtered = data.filter(
        (item) =>
          item.campaign_title?.toLowerCase().includes(lowerCaseQuery) ||
          item.campaign_obj?.toLowerCase().includes(lowerCaseQuery) ||
          item.product_name?.toLowerCase().includes(lowerCaseQuery)
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, data]); // Re-filter when query or data changes

  const handleIncrement = (platformIndex, itemIndex) => {
    const newContentTypes = [...contentTypes];
    newContentTypes[platformIndex].items[itemIndex].count += 1;
    setContentTypes(newContentTypes);
  };

  const handleDecrement = (platformIndex, itemIndex) => {
    const newContentTypes = [...contentTypes];
    const currentCount = newContentTypes[platformIndex].items[itemIndex].count;
    if (currentCount > 0) {
      newContentTypes[platformIndex].items[itemIndex].count -= 1;
      setContentTypes(newContentTypes);
    }
  };

  const handleCheckboxChange = (platformIndex, itemIndex) => {
    const newContentTypes = [...contentTypes];
    newContentTypes[platformIndex].items[itemIndex].checked =
      !newContentTypes[platformIndex].items[itemIndex].checked;
    setContentTypes(newContentTypes);
  };

  const handleNextbtn = () => {
    if (currentStep < totalSteps) {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const handlePrevbtn = () => {
    if (currentStep > 1) {
      setCurrentStep((prevStep) => prevStep - 1);
    }
  };
  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    setEndDate(""); // Reset end date when start date changes
    setShowContent(false);
  };
  const formatSingleDate = (dateString) => {
    if (!dateString) return ""; // Handle empty or invalid dates
    const date = new Date(dateString);

    // Ensure valid date
    if (isNaN(date.getTime())) return "";

    const day = date.getUTCDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getUTCFullYear();

    return `${day} ${month}, ${year}`;
  };

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return "th"; // Special case for 11, 12, 13
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    setLoading(true);
    setShowContent(false);

    setTimeout(() => {
      setLoading(false);
      setShowContent(true);
    }, 2000); // Show loader for 2 seconds
  };

  const currentDate = new Date().toISOString().split("T")[0];

  const totalSteps = 4;

  const handleNext = () => {
    setCurrentStep((prev) => Math.min(prev + 1, totalSteps));
  };
  // const location = useLocation();

  // Optional: Fetch data when the tab changes
  // const handleTabChange = (tabName) => {
  //   setActiveTab(tabName);
  //   // fetchData(); // Uncomment if needed
  // };
  const handlePrev = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };
  const [selectedAge, setSelectedAge] = useState(null);

  const ageGroups = [
    "13-17",
    "18-24",
    "25-34",
    "35-44",
    "45-54",
    "55-64",
    "65+",
  ];

  const handleAgeSelect = (age) => {
    setSelectedAge(age);
  };

  const handleSaveDraft = () => {
    // Log save draft response here
    console.log("Draft Saved:", {
      startDate,
      endDate,
      contentTypes,
      selectedAge,
    });
  };

  const handlePublish = () => {
    // Log publish response here
    console.log("Campaign Published:", {
      startDate,
      endDate,
      contentTypes,
      selectedAge,
    });
  };
  // const ViewDetails = (id) => {
  //   navigate(`/campaign-details/${id}`);
  // };

  const navigate = useNavigate();
  const createNavigate = () => {
    navigate("/campaign-create");
  };
  useEffect(() => {
    getRequest("Received");
  }, []);
  const [error, setError] = useState(null);

  // Display loading message or spinner while fetching data
  if (loading) {
    return <div>Loading...</div>; // Or you can replace this with a spinner or animation
  }
  const today = new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD in local time

  const NoRecords = () => {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center px-4 max-w-md mx-auto">
          <div>
            <img src={NoCamp} alt="No Campaigns" className="object-contain" />
          </div>

          <>
            <h2 className="Title">Welcome to the Campaign!</h2>
            <p className="text-gray-600 mb-8">
              Welcome to the Dashboard It looks like you haven't created any
              campaigns yet. Ready to launch your first one?
            </p>
          </>
        </div>
      </div>
    );
  };

  const getRequest = async (statusKey) => {
    const normalizedKey = statusKey.toLowerCase(); // Convert to lowercase for internal matching
    const statusObj = statusMap.find((status) => status.key === normalizedKey);
    if (!statusObj) {
      console.error(`Invalid statusKey: ${statusKey}`);
      return;
    }

    const { field } = statusObj;

    // Send key to API with only first letter capitalized (e.g., Received, Sent, Pending)
    const capitalizedKey =
      statusKey.charAt(0).toUpperCase() + statusKey.slice(1);

    try {
      const response = await axiosMain.get(
        "/api/campaign/influencer-campaign-status",
        {
          params: {
            user_id: localStorage.getItem("user_id"),
            [field]:
              capitalizedKey === "Pending"
                ? "Accepted"
                : capitalizedKey,
          },
        }
      );

      setFilteredData(response.data.data.requests);
      setStatusCounts(response.data.data.requestStatusCountData[0] || {});
      setActiveTab(normalizedKey); // use lowercase internally
    } catch (error) {
      console.error("Error fetching campaign requests:", error);
    }
  };

  const statusMap = [
    {
      label: "Request Sent",
      key: "sent",
      field: "request_status",
      countField: "sent",
    },
    {
      label: "Request Received ",
      key: "received",
      field: "request_status",
      countField: "received",
    },

    {
      label: "Request Accepted",
      key: "accepted",
      field: "request_status",
      countField: "accepted",
    },
    {
      label: "Request Rejected",
      key: "rejected",
      field: "request_status",
      countField: "rejected",
    },
    {
      label: "Contract Received",
      key: "pending",
      field: "contract_status",
      countField: "contract_pending",
    },
  ];

  return (
    <>
      <div className="campaignCreate">
        <div className="SearchFilterSection">
          <div className="d-flex justify-content-end align-items-center w-100">
            <div className="d-flex justify-content-end shadow-none">
              {/* Pass the required props to SearchBar */}
              <SearchBar
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                placeholder="Search"
              />
            </div>
            {data?.length > 0 ? (
              <>
                {/* Remove or comment out the duplicate hardcoded search input below, as SearchBar handles it now */}
                {/* 
                <div className="Campaign SearchInput d-flex align-items-center">
                  <img
                    src={Search}
                    className="img-fluid me-2"
                    alt="Search Icon"
                    style={{ width: "20px", height: "20px" }}
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)} // Add this if keeping, but duplicate
                  />
                </div>
                */}

                {/* Create Button on Top Right (only for brand role) */}
                {userData?.role === "brand" && (
                  <div>
                    <button
                      onClick={() => createNavigate()}
                      className="CreateGreenBtn"
                    >
                      Create new Campaign
                      <img
                        src={create}
                        className="img-fluid"
                        alt="Create Icon"
                      />
                    </button>
                  </div>
                )}
              </>
            ) : (
              /* No button here when no campaigns */
              <></>
            )}
          </div>
        </div>
        <div className="CreatedCampaigns mt-4">
          <ul className="nav nav-tabs mb-4">
            {statusMap.map(({ label, key, countField }) => (
              <li
                className="nav-item"
                key={key}
                onClick={() =>
                  getRequest(key.charAt(0).toUpperCase() + key.slice(1))
                } // pass Capitalized
                style={{ cursor: "pointer" }}
              >
                <button
                  className={`nav-link ${
                    activeTab === key || (!activeTab && key === "received")
                      ? "active"
                      : ""
                  }`}
                  type="button"
                >
                  {label} ({statusCounts[countField] || 0})
                </button>
              </li>
            ))}
          </ul>

          <div className="tab-content">
            <div className="row g-4">
              {filteredData?.length > 0 ? (
                filteredData.map((ele) => (
                  <div
                    key={ele.campaign_id}
                    className="col-xl-3 col-lg-4 col-md-6"
                  >
                    <div className="campaign-card">
                      <div className="influencer-home-image">
                        <img
                          src={ele.campaign_poster || DummyImg}
                          alt={ele.campaign_title}
                          className="campaign-image influencer-home w-100"
                        />
                      </div>
                      <div className="p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="StatusCamp">
                            <h5 className="mb-1">{ele.campaign_title}</h5>
                            <span className="CreatedShap">
                              {ele?.camping_created_date === today
                                ? "Ongoing"
                                : ""}
                            </span>
                          </div>
                        </div>
                        <p className="mb-2">{ele.campaign_obj}</p>
                        <div className="d-flex align-items-center mb-2">
                          <span className="date-text text-black">
                            <img
                              src={CalenderImg}
                              alt="calendar"
                              className=""
                            />
                            {formatSingleDate(ele.start_date)} -{" "}
                            {formatSingleDate(ele.end_date)}
                          </span>
                        </div>
                        {/* <span className="location-text">
                          <img src={LocationImg} alt="location" />
                          {ele.city}, {ele.state}
                        </span> */}
                        <hr />
                        <div className="mb-3">
                          <div className="influencer-home-product">
                            Product Name
                          </div>
                          <div className="text-black">
                            {ele.product_name || "-"}
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="influencer-home-product">Budget</div>
                          <div className="text-black fw-medium">
                            {ele?.budget && !isNaN(ele.budget)
                              ? new Intl.NumberFormat("en-IN", {
                                  style: "currency",
                                  currency: "INR",
                                }).format(ele.budget)
                              : "N/A"}
                          </div>
                        </div>
                        {/* <hr /> */}
                        <div className="mb-3">
                          <div className="influencer-home-product">
                            Deliverables
                          </div>
                          <div>
                            <div className="d-flex">
                              {(() => {
                                const firstWeek =
                                  ele.timeline && ele.timeline.length > 0
                                    ? ele.timeline[0]
                                    : null;

                                const hasInstagramContent =
                                  firstWeek &&
                                  firstWeek.Instagram &&
                                  (firstWeek.Instagram.reels > 0 ||
                                    firstWeek.Instagram.posts > 0 ||
                                    firstWeek.Instagram.story > 0);

                                const hasYouTubeContent =
                                  firstWeek &&
                                  firstWeek.YouTube &&
                                  (firstWeek.YouTube.shorts > 0 ||
                                    firstWeek.YouTube.videos > 0 ||
                                    firstWeek.YouTube.live_stream > 0);

                                return (
                                  <>
                                    {hasInstagramContent && (
                                      <div className="campaign-image-container me-3">
                                        <img
                                          src={instaDeliverables}
                                          alt="Instagram"
                                          className="social-media-icon-campaign"
                                        />
                                      </div>
                                    )}

                                    {hasYouTubeContent && (
                                      <div className="campaign-image-container">
                                        <img
                                          src={youtubeDeliverables}
                                          alt="YouTube"
                                          className="social-media-icon-campaign"
                                        />
                                      </div>
                                    )}
                                  </>
                                );
                              })()}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <button>{ele.request_status}</button> */}
                      <button onClick={() => ViewDetails(ele.campaign_id)}>
                        View Details
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <NoRecords />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
